import React from 'react'
import styled from 'styled-components';

const Form = ({
  children,
  title,
  margin,
  padding,
  width,
  height,
  backgroundColor,
  boxShadow,
  ...props
}) => {
  return (
    <Wrapper
      margin={margin}
      padding={padding}
      width={width}
      height={height}
      backgroundColor={backgroundColor}
      boxShadow={boxShadow}
      {...props}
    >
      {title &&
        <Title>{title}</Title>
      }
      {children}
    </Wrapper>
  )
}

export default Form;

const Wrapper = styled.form`
    margin:${props => props.margin ? props.margin : '2%'};
    padding: ${props => props.padding ? props.padding : '16px 40px'};
    width: ${props => props.width ? props.width : '40%'};
    height: ${props => props.height ? props.height : '100%'};
    background-color: ${props => props.backgroundColor ? props.backgroundColor : 'var(--color-blanco)'};
    border-radius: 10px;
    box-shadow: ${props => props.boxShadow ? props.boxShadow : '20px 20px 40px rgba(0, 0, 0, 0.25)'};
    display: flex;
    flex-direction: column;
    align-items: center;
`;

const Title = styled.h1`
    margin: 16px 0;
`;



